import React, { useState } from 'react';

/**
 * Props:
 * - output: array of strings
 * - loading: bool
 * - error: string|null
 * - onAddToDraft: fn(selected[])     // curator mode
 * - onPublish:    fn(singleString)  // ai-only mode
 * - scenario:    'curator'|'co-write'|'ai-only'
 * - pid: participant ID
 */

const logModelSelection = async (pid, scenario, selectedResponses, allResponses) => {
    try {
        await fetch('/api/log/model-selection', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                pid,
                scenario,
                selected_responses: selectedResponses,
                all_responses: allResponses
            })
        });
    } catch (error) {
        console.error('Error logging model selection:', error);
    }
};

function ModelOutputSection({
                                output,
                                loading,
                                error,
                                onAddToDraft,
                                onPublish,
                                scenario,
                                pid
                                           }) {
    const [selected, setSelected] = useState([]);

    const toggleSelection = (resp) => {
        //modified to log the selection change
        let newSelected;
        if (scenario === 'ai-only') {
            // single-select toggle
            newSelected = selected[0] === resp ? [] : [resp];
        } else {
            // multi-select
            newSelected = selected.includes(resp)
                ? selected.filter(r => r !== resp)
                : [...selected, resp];
        }

        setSelected(newSelected);

        if (pid) {
            logModelSelection(pid, scenario, newSelected, output);
        }
    };

    const handleAddToDraft = () => {
        if (onAddToDraft && selected.length > 0) {
            if (pid) {
                logModelSelection(pid, scenario, selected, output);
            }
            onAddToDraft(selected);
            setSelected([]); // Clear selection after adding
        }
    };

    const handlePublish = () => {
        if (onPublish && selected.length === 1) {
            // Log the final publish selection
            if (pid) {
                logModelSelection(pid, scenario, selected, output);
            }
            onPublish(selected[0]);
        }
    };

    return (
        <div className="model-output-section">
            <h2 className="section-title">Model Outputs</h2>
            <div className="output-content">
                {loading ? (
                    <p>Generating poetry...</p>
                ) : error ? (
                    <p className="error-message">{error}</p>
                ) : output.length === 0 ? (
                    <p>No output yet. Configure and click Generate.</p>
                ) : (
                    output.map((resp, idx) => (
                        <div key={idx} className="output-response">
                            <div
                                className={`output-circle ${selected.includes(resp) ? 'selected' : ''}`}
                                onClick={() => toggleSelection(resp)}
                            />
                            <div className="output-text">{resp}</div>
                        </div>
                    ))
                )}
            </div>

            {/* Curator mode: Add to Draft */}
            {scenario === 'curator' && (
                <button
                    className="add-to-draft-button"
                    onClick={handleAddToDraft}
                    disabled={selected.length === 0}
                >
                    Add to Draft
                </button>
            )}

            {/* AI-Only mode: Publish */}
            {scenario === 'ai-only' && (
                <button
                    className="publish-button"
                    onClick={handlePublish}
                    disabled={selected.length !== 1}
                >
                    Publish
                </button>
            )}
        </div>
    );
}

export default ModelOutputSection;